var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', _vm._g(_vm._b({}, 'div', _vm.$attrs, false), _vm.$listeners), [_vm.hasExcluding ? _c('div', [_c('v-tooltip', {
    attrs: {
      "top": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref) {
        var on = _ref.on,
          attrs = _ref.attrs;
        return [_c('span', _vm._g(_vm._b({
          "class": _vm.excludingClasses
        }, 'span', attrs, false), Object.assign({}, on, _vm.listenersProxy)), [_c('stroke', {
          attrs: {
            "strike": _vm.strike
          }
        }, [_vm._v(" " + _vm._s(_vm.price(_vm.excludingVat, _vm.currency)) + " ")]), _vm.showUnit ? [_vm._v(" / " + _vm._s(_vm.unitDisplay) + " ")] : _vm._e()], 2)];
      }
    }], null, false, 652369937)
  }, [_c('div', {
    staticClass: "price-tooltip-content"
  }, [_c('div', [_vm._v(_vm._s(_vm.$translate("excludingVat")))]), _vm.tooltip ? _c('div', [_vm._v(_vm._s(_vm.tooltip))]) : _vm._e()])])], 1) : _vm._e(), _vm.hasIncluding ? _c('div', {
    staticClass: "mt-1",
    "class": _vm.includingWrapperClasses
  }, [_c('v-tooltip', {
    attrs: {
      "top": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref2) {
        var on = _ref2.on,
          attrs = _ref2.attrs;
        return [_c('span', _vm._g(_vm._b({
          "class": _vm.includingClasses
        }, 'span', attrs, false), Object.assign({}, on, _vm.listenersProxy)), [_c('stroke', {
          attrs: {
            "strike": _vm.strike
          }
        }, [_vm._v(" " + _vm._s(_vm.price(_vm.includingVat, _vm.currency)) + " ")]), _vm.showUnit ? [_vm._v(" / " + _vm._s(_vm.unitDisplay) + " ")] : _vm._e()], 2)];
      }
    }], null, false, 1403875025)
  }, [_c('div', {
    staticClass: "price-tooltip-content"
  }, [_c('div', [_c('span', [_vm._v(_vm._s(_vm.$translate("includingVat")))]), _vm.vatRate ? [_c('span', [_vm._v(" (" + _vm._s(_vm.$translate("vat_rate")) + " " + _vm._s(_vm.percent(_vm.vatRate)) + ") ")])] : _vm._e()], 2), _vm.tooltip ? _c('div', [_vm._v(_vm._s(_vm.tooltip))]) : _vm._e()])])], 1) : _vm._e()]);

}
var staticRenderFns = []

export { render, staticRenderFns }